import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import FONTS from '../../../constants/fonts'
import MEDIA from '../../../constants/media'
import COLORS from '../../../constants/colors'

export const PageHeroWrapper = styled.div`
  position: relative;
  height: 370px;
  &.bgr-right {
    img {
      object-position: center right !important;
    }
  }
  &.bgr-top-right {
    img {
      object-position: right top !important;
    }
  }
`
export const PageHeroTitleWrapper = styled.div`
  position: absolute;
  background: ${COLORS.BLUETRANS};
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;
`
export const PageHeroTitle = styled.h1`
  color: ${COLORS.WHITE};
  max-width: 1024px;
  padding: 10px 20px;
  font-size: 4rem;
  font-weight: ${FONTS.WEIGHTLIGHT};
  text-align: center;
  width: 100%;
  margin: 0;
  ${MEDIA.small`
    padding: 20px;
    font-size: ${FONTS.FONTTITLE};
`}
`
export const PageTitle = styled(PageHeroTitle)`
  background: ${COLORS.BLUETRANS};
  color: ${COLORS.WHITE};
  padding: 10px 20px;
  font-size: 4rem;
  font-weight: ${COLORS.WEIGHTLIGHT};
  bottom: 0;
  text-align: center;
  width: 100%;
  margin: 146px 0 0 0;
  position: relative;
  ${MEDIA.small`
    padding: 20px;
    font-size: ${FONTS.FONTTITLE};
  `}
`

const PageHero = (props) => (
  <PageHeroWrapper className={props.position}>
    <Img
      className="page-hero-image-wrapper"
      css={{
        height: '100%',
      }}
      fluid={props.background}
    />
    <PageHeroTitleWrapper className="page-hero-title-wrapper">
      <PageHeroTitle>{props.title}</PageHeroTitle>
    </PageHeroTitleWrapper>
  </PageHeroWrapper>
)

export default PageHero
